import type { ApiClient } from '@travel/api-client';
import env from '@travel/env';

import { ReservationType } from 'constants/reservations';
import type {
  BookingConfirmationEmailAPIParams,
  BookingConfirmationEmailAPIResponse,
  BookingDetailRequestBody,
  BookingDetailResponseBody,
} from 'ReservationsDetails-Types';

export const getBookingDetailAPI = async (
  http: ApiClient,
  params: BookingDetailRequestBody,
): Promise<BookingDetailResponseBody> => {
  return http.post(
    `/myapi/web/myBooking/?bookingId=${params.bookingId}&type=${params.type || ReservationType.UPCOMING}`,
    {
      customParams: { isTravelAPI: true },
      ignoreCommonErrorHandler: true,
      withAuthCode: true,
    },
  );
};

export const callBookingConfirmationEmailAPI = async (
  params: BookingConfirmationEmailAPIParams,
): Promise<BookingConfirmationEmailAPIResponse> => {
  const { reservationId, csrfKey, emails } = params;
  const url = `${env('UNIVERSAL_API_OLD_MYPAGE_BASE_URL')}/traveler-tool/jp/mail/web/kakunin`;

  const formData = new URLSearchParams({
    cmailType: '03',
    yoyakuNo: reservationId,
    key: csrfKey,
    ...Object.fromEntries(emails.map((email, i) => [`mail${i + 1}`, email])),
  });

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: formData.toString(),
      credentials: 'include',
    });
    const data = await response.json();
    if (data === null || data === undefined) {
      throw new Error();
    }

    return {
      success: !!data.success,
    };
  } catch (error) {
    return { success: false };
  }
};
